export const DOMAIN_HOST_IMG = "https://imgs.yatajjer.com/";
//export const DOMAIN_HOST = 'https://localhost:7270/api/v1/';

export const URL_IMG_CALENDER = DOMAIN_HOST_IMG + "calender/";
export const Infinity200px = "../imgs/Infinity200px.gif";
